var _circle, _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5013,
    cy: 4.99984,
    r: 3.33333,
    fill: "#5F6366"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5013,
    cy: 14.1673,
    rx: 5.83333,
    ry: 3.33333,
    fill: "#5F6366"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4996 14.1669C17.4996 15.5476 15.8033 16.6669 13.7322 16.6669C14.3424 16 14.762 15.1628 14.762 14.1681C14.762 13.1722 14.3414 12.3343 13.7301 11.667C15.8012 11.667 17.4996 12.7862 17.4996 14.1669Z",
    fill: "#5F6366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 5.00049C14.9996 6.3812 13.8803 7.50049 12.4996 7.50049C12.1985 7.50049 11.9099 7.44727 11.6426 7.34972C12.0368 6.65631 12.262 5.85423 12.262 4.99956C12.262 4.14552 12.0372 3.34399 11.6435 2.65093C11.9105 2.55359 12.1989 2.50049 12.4996 2.50049C13.8803 2.50049 14.9996 3.61978 14.9996 5.00049Z",
    fill: "#5F6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.d3e149ff675f457b7d9bedc2ef3cd06e.svg";
export { ForwardRef as ReactComponent };